import * as React from "react";
import { type ChevronProps } from "react-day-picker";

import { faChevronLeft, faChevronRight } from "@performyard/fontawesome/pro-regular-svg-icons";

import { Icon } from "../../atoms/Icon";
import { SingleSelectInput } from "../SelectInputs/SingleSelectInput";
import { DROPDOWN_CONFIG, TIME_OPTIONS } from "./config";

export const ChevronComponent = ({ orientation }: Omit<ChevronProps, "size" | "disabled">) => {
	const icon = orientation === "left" ? faChevronLeft : faChevronRight;
	return <Icon icon={icon} size={16} />;
};

// Types for dropdown component props (matching react-day-picker expectations)
type DropdownComponentProps = {
	components: Record<string, unknown>;
	classNames: Record<string, string>;
	options?: Array<{ label: string; value: number }>;
} & Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "children">;

const createDropdownComponent = (config: { width: string; className: string }) => {
	const DropdownComponent = (props: DropdownComponentProps) => {
		const { value, onChange, options } = props;

		const handleChange = React.useCallback(
			(selectedValue: number | null) => {
				if (onChange && selectedValue !== null) {
					onChange({
						target: { value: selectedValue.toString() },
					} as React.ChangeEvent<HTMLSelectElement>);
				}
			},
			[onChange]
		);

		return (
			<div className={config.width}>
				<SingleSelectInput
					value={typeof value === "number" ? value : parseInt((value as string) || "0", 10)}
					options={options || []}
					onChange={handleChange}
					dangerouslySetClassName={config.className}
				/>
			</div>
		);
	};

	DropdownComponent.displayName = "DropdownComponent";
	return DropdownComponent;
};

export const YearsDropdown = createDropdownComponent(DROPDOWN_CONFIG.years);
export const MonthsDropdown = createDropdownComponent(DROPDOWN_CONFIG.months);

export const TimeSelector = ({
	currentHour,
	onTimeChange,
}: {
	currentHour: number;
	onTimeChange: (hour: string | number | null) => void;
}) => (
	<div className="-mx-2 flex justify-center bg-neutral-1 px-2 pb-2 pt-3">
		<div className={DROPDOWN_CONFIG.time.width}>
			<SingleSelectInput
				value={currentHour}
				options={TIME_OPTIONS}
				onChange={onTimeChange}
				dangerouslySetClassName={DROPDOWN_CONFIG.time.className}
			/>
		</div>
	</div>
);
